import { zodResolver } from '@hookform/resolvers/zod';
import { Address } from '@pelicargo/types';
import { useEffect } from 'react';
import { useForm, UseFormReturn } from 'react-hook-form';
import { z } from 'zod';

import { getDifferences } from '../../utils/findChangedKeys';

export type UseAddressForm = { methods: UseFormReturn<Address> };
type Options = { isCreate: boolean };

const defaultOptions = { isCreate: false };

export const addressOptional = z.object({
  recipient: z.string().nullish(),
  line_one: z.string().nullish(),
  line_two: z.string().nullish(),
  city: z.string().nullish(),
  state: z.string().nullish(),
  zip_code: z.string().nullish(),
  country: z.string().nullish(),
});

export const useAddressForm = (data?: Address, { isCreate }: Options = defaultOptions): UseAddressForm => {
  const methods = useForm<Address>({
    mode: 'onBlur',
    resolver: zodResolver(addressOptional),
    defaultValues: data,
  });
  const { getValues, setValue } = methods;

  useEffect(() => {
    const updateFields = () => {
      const changes = getDifferences<Address>(getValues(), data);
      if (!changes.length) return;

      for (const [key, value] of changes) {
        if (value !== undefined) setValue<any>(key, value);
      }
    };

    // Run if we're not on create & we have data
    if (!isCreate && data) updateFields();
  }, [data, getValues, setValue, isCreate]);

  return { methods: { ...methods, getValues, setValue } };
};
